import {request} from './repository';

const url = 'questions/';


const questionStore = {
    storeQuestion(data) {
        return request.post(url, data);
    },
    updateQuestion(id, data) {
        return request.put(url + id, data);
    },
    reorderQuestions(data) {
        return request.post(url + 'reorder', data);
    },
    deleteQuestion(id) {
        return request.delete(url + id);
    },
    deleteQuestionFile(id, data) {
        return request.post(url + id + '/destroy-file', data);
    }
}

export default questionStore;
